import { type Organization, type WithContext } from "schema-dts";
import {
  ORGANIZATION_EMAIL,
  ORGANIZATION_LOGO,
  ORGANIZATION_NAME,
  ORGANIZATION_PHONE,
  ORGANIZATION_URL,
} from "../constants";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  url: ORGANIZATION_URL,
  name: ORGANIZATION_NAME,
  logo: ORGANIZATION_LOGO,
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: ORGANIZATION_PHONE,
      contactType: "customer service",
    },
  ],
  email: ORGANIZATION_EMAIL,
  knowsLanguage: "es-CO, es-MX, en-US",
  sameAs: [
    "https://www.instagram.com/fithub_co",
    "https://www.facebook.com/FitHubco",
    "https://www.youtube.com/channel/UCCVbPuguSB8X7CU7jZdgsoQ",
    "https://www.linkedin.com/company/fithub-colombia",
  ],
  slogan: "Evoluciona tus habitos",
  location: [
    {
      "@type": "Place",
      name: "FitHub Bogotá",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Bogotá",
        addressRegion: "Bogotá",
        addressCountry: "CO",
        streetAddress: "Calle 93a #11-46",
      },
    },
    {
      "@type": "Place",
      name: "FitHub Medellín",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Medellín",
        addressCountry: "CO",
      },
    },
    {
      "@type": "Place",
      name: "FitHub Barranquilla",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Atlántico",
        addressRegion: "Baranquilla",
        addressCountry: "CO",
        streetAddress: "Cra 51 # 82-223",
      },
    },
  ],
} satisfies WithContext<Organization>;

export default organizationSchema;
